export const ozToLb = (ounces = 0) => {
  return ounces / 16
}
